import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Event } from "../Entities/Event/Event";
import { EventInterface } from "../Entities/Event/EventInterface";
import ChargeFactory from "./ChargeFactory";
import PaymentFactory from "./PaymentFactory";

import { AttachmentInterface } from "../Entities/Attachment/AttachmentInterface";
import AttachmentFactory from "./AttachmentFactory";

class EventFactory extends Factory implements FactoryInterface {

  public create(data: any): EventInterface {
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(data.attachments);
    return new Event({
      id: data.id,
      eventTypeId: data.eventTypeId,
      companyId: data.companyId,
      propertyId: data.propertyId,
      unitId: data.unitId,
      chargeId: data.chargeId,
      paymentId: data.paymentId,
      contractId: data.contractId,
      personId: data.contactId,
      content: !!data.content && typeof data.content === "string" ? JSON.parse(data.content) : data.content,
      hidden: data.hidden,
      removed: data.removed,
      createdBy: data.createdBy,
      updatedBy: data.updatedBy,
      createdAt: new Date(data.createdAt),
      snoozeDate: data.snoozeDate === null ? null : new Date(data.snoozeDate),
      refersToEventId: data.refersToEventId,
      read: data.read,
      viewed: data.viewed,
      reacted: data.reacted,
      charge: !!data.charge ? ChargeFactory.create(data.charge) : null,
      payment: !!data.payment ? PaymentFactory.create(data.payment) : null,
      event: !!data.event ? this.create(data.event) : null,
      taskId: data.taskId,
      conversationId: data.conversationId,
      attachments: attachments,
      amazonFolderName: data.amazonFolderName,
      reporterId: data.reporterId,
      executorId: data.executorId,
      executionDate: data.executionDate === null ? null : new Date(data.executionDate),
      countOfTasks: data.countOfTasks,
      remindDate: data.remindDate,
      countOfActiveTasks: data.countOfActiveTasks,
      financialStatementId: data.financialStatementId || null
    });
  }

  public reinitialize(data: any): EventInterface {
    return new Event({
      ...data
    });
  }
}

export default new EventFactory();
